import pttStartUrl from "@/assets/sounds/ptt-start.mp3";
import pttEndUrl from "@/assets/sounds/ptt-end.mp3";
import peekNotificationUrl from "@/assets/sounds/peek-notification.mp3";
import { localStorageModule } from "@/modules/local-storage";

/**
 * Audio cues for the floating widget. A fresh element per play lets rapid
 * cues overlap instead of cutting each other off; playback is best-effort —
 * a failure (no output device, interrupted load) must never break the
 * interaction it decorates.
 */
const play = (url: string): void => {
  const audio = new Audio(url);
  void audio.play().catch(() => undefined);
};

/** Recording is live — the user can speak. */
export const playPttStartSound = (): void => play(pttStartUrl);

/** PTT key released while recording. */
export const playPttEndSound = (): void => play(pttEndUrl);

/** A new peek bubble arrived. */
export const playPeekNotificationSound = (): void => {
  if (!localStorageModule.readMemAgentNewMessageSoundEnabled()) return;

  play(peekNotificationUrl);
};
